import React, { PureComponent } from 'react';
import { shipperOrders, action } from '../propTypes';

import TableStyled, { TableRowStyled, TableHeaderCellStyled } from './styled';

import TableCellId from './TableCellId';
import TableCellStarts from './TableCellStarts';
import TableCellStatus from './TableCellStatus';
import TableCellChanges from './TableCellChanges';

const t = {
  order_id: 'Order ID',
  starts: 'Starts',
  status: 'Status',
  will_be_created: 'Will be created',
  will_be_canceled: 'Will be canceled',
  will_be_modified: 'Will be modified',
  will_not_be_modified: 'Will not be modified',
};

class RoChangesPreviewTable extends PureComponent {
  render() {
    const { shipperOrders, action } = this.props;
    return (
      <TableStyled>
        <thead>
          <tr>
            <TableHeaderCellStyled> {t.order_id} </TableHeaderCellStyled>
            <TableHeaderCellStyled> {t.starts} </TableHeaderCellStyled>
            <TableHeaderCellStyled> {t.status} </TableHeaderCellStyled>
          </tr>
        </thead>
        <tbody>
          {shipperOrders.map((so, index) => (
            <TableRowStyled key={index}>
              <TableCellId id={so.id} />
              <TableCellStarts
                dateFrom={so.start_time_from}
                dateTo={so.start_time_to}
                dateFromTz={so.start_time_from_tz}
                dateToTz={so.start_time_to_tz}
              />
              <TableCellStatus status={so.status} />
              <TableCellChanges change={so.change} action={action} />
            </TableRowStyled>
          ))}
        </tbody>
      </TableStyled>
    );
  }
}

RoChangesPreviewTable.propTypes = {
  shipperOrders,
  action,
};

RoChangesPreviewTable.defaultProps = {
  shipperOrders: [],
};

export default RoChangesPreviewTable;
